import { Disclosure } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
  {
    question: "How much data is in the database?",
    answer:
      "The database has data on 24.000+ software products across 700 product categories.",
  },
  {
    question: "How often do you update the data?",
    answer:
      "We update the data quartlery. At the end of each quarter, we'll upload the data of the previous quarter.",
  },
  {
    question: "Can I get a refund?",
    answer:
      "Yes, you can get a 100%, no-question-asked refund for 14 days after your purchase. Just send an email to matthias@saasfyi.co.",
  },
  {
    question: "How many software categories are included?",
    answer:
      "We have products from 700+ software categories in the database.",
  },
  {
    question: "Where can I contact you?",
    answer:
      "For further questions or inquiries, send us an email at matthias@saasfyi.co.",
  },
]

export default function FAQs() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40" id="faqs">
        <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900">Frequently asked questions</h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">{faq.question}</span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          ) : (
                            <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
